import { useRef } from "react";
import Video from "../../../../Components/Icons/Video";
import Doc from "../../../../Components/Icons/Doc";
import Xls from "../../../../Components/Icons/Xls";
import Txt from "../../../../Components/Icons/Txt";
import Pdf from "../../../../Components/Icons/Pdf";


function Attachements({
  preview,
  handleChange,
  width,
  label,
  multiple = false,
}) {
  const fileInputRef = useRef();

  //  const imagetype = ["png", "jpg", "jpeg", "PNG", "gif", "webp", "jfif"];
  const filetype = ["docx", "doc", "xlsx", "xls", "pdf", "txt", "pptx"];
  const videotype = ["mp4", "mov", "wmv", "avi", "flv", "mkv"];

  return (
    <div className={`${width}`}>
      <div className=" my-3 px-3 flex items-center  justify-end gap-4">
        <div className=" flex items-center gap-2">
          {preview &&
            preview.map((file, idx) => {
              console.log("ss", file);
              let Ext = file.split(".").reverse()[0];
              return (
                <div
                  className=" w-10 h-10 my-2 rounded overflow-hidden"
                  key={idx}
                >
                  {videotype.includes(Ext) ? <Video /> : null}

                  {Ext == ("docx" || "doc"||"txt") ? (
                    <Doc />
                  ) : Ext == ("xlsx" || "xls") ? (
                    <Xls />
                  ) : Ext == "txt" ? (
                    <Txt />
                  ) : Ext == "pdf" ? (
                    <Pdf />
                  ) : Ext == "pptx" ? (
                    <>No file</>
                  ) : 
                  <img src={file} alt="#" width="120%" />

                  }

                </div>
              );
            })}
        </div>
        <input
          onChange={handleChange}
          multiple={multiple}
          ref={fileInputRef}
          type="file"
          accept="audio/*,video/*,image/*,.pdf,.doc,.docx,.ppt, .pptx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
          hidden
        />
        <div
          className=" flex gap-3 items-center justify-center py-2 rounded-md bg-[#DEF0FA] px-3 cursor-pointer"
          onClick={() => fileInputRef.current.click()}
        >
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.2721 1.85642C10.1503 1.73454 10.0056 1.63786 9.84632 1.5719C9.68708 1.50594 9.51641 1.47199 9.34404 1.47199C9.17168 1.47199 9.00101 1.50594 8.84177 1.5719C8.68253 1.63786 8.53784 1.73454 8.41596 1.85642L2.0343 8.23809C1.62408 8.64838 1.39366 9.20482 1.39371 9.785C1.39377 10.3652 1.6243 10.9216 2.03459 11.3318C2.44488 11.742 3.00132 11.9724 3.5815 11.9724C4.16168 11.9723 4.71808 11.7418 5.1283 11.3315L9.61588 6.84392C9.69881 6.76664 9.80851 6.72457 9.92185 6.72657C10.0352 6.72857 10.1433 6.77448 10.2235 6.85464C10.3036 6.9348 10.3496 7.04294 10.3516 7.15628C10.3536 7.26963 10.3115 7.37932 10.2342 7.46226L5.74663 11.9498C5.46363 12.2403 5.12576 12.4716 4.75265 12.6304C4.37953 12.7892 3.97859 12.8723 3.57309 12.875C3.16759 12.8776 2.76561 12.7996 2.39047 12.6457C2.01533 12.4917 1.67451 12.2648 1.38777 11.978C1.10103 11.6913 0.874096 11.3505 0.720127 10.9753C0.566159 10.6002 0.488225 10.1982 0.490848 9.79271C0.493471 9.38721 0.576598 8.98627 0.735406 8.61315C0.894214 8.24004 1.12554 7.90218 1.41596 7.61917L7.79705 1.23751C8.20734 0.827293 8.76378 0.596869 9.34396 0.596924C9.92414 0.596979 10.4805 0.827508 10.8908 1.2378C11.301 1.64809 11.5314 2.20453 11.5313 2.78471C11.5313 3.36489 11.3008 3.92129 10.8905 4.33151L4.51288 10.7091L4.50821 10.7138L4.50413 10.7178L4.50296 10.719L4.50121 10.7202C4.25176 10.953 3.92143 11.0795 3.58026 11.0729C3.23909 11.0663 2.91391 10.9271 2.67365 10.6848C2.43339 10.4425 2.29694 10.1161 2.29323 9.77493C2.28953 9.43372 2.41885 9.10448 2.6538 8.85701L7.20963 4.30117C7.2921 4.22144 7.4026 4.17729 7.51731 4.17823C7.63202 4.17917 7.74177 4.22513 7.82293 4.30621C7.90408 4.38729 7.95015 4.497 7.9512 4.61171C7.95225 4.72642 7.9082 4.83695 7.82855 4.91951L3.27271 9.47534C3.1901 9.55687 3.14325 9.66788 3.14249 9.78395C3.14172 9.90002 3.1871 10.0116 3.26863 10.0943C3.35016 10.1769 3.46117 10.2237 3.57724 10.2245C3.69331 10.2252 3.80493 10.1799 3.88755 10.0983L10.2721 3.71201C10.394 3.59013 10.4907 3.44544 10.5566 3.2862C10.6226 3.12696 10.6566 2.95628 10.6566 2.78392C10.6566 2.61156 10.6226 2.44089 10.5566 2.28165C10.4907 2.12241 10.394 1.9783 10.2721 1.85642Z"
              fill="#119DEE"
            />
          </svg>
          <p className=" text-xs font-medium text-[#119DEE]">
            {label ? label : ""}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Attachements;
